export interface FormStrings {
  dialogTitle: string;
  emailLabel: string;
  googleLabel: string;
  appleLabel: string;
  linkedInLabel: string;
}

export class Constants {
  //Validation Messages
  static FIRST_NAME_VALIDATION_MESSAGE =
    "First name must be at least 2 characters.";
  static LAST_NAME_VALIDATION_MESSAGE =
    "Last name must be at least 2 characters.";
  static PHONE_NUMBER_VALIDATION_MESSAGE = "Invalid phone number.";
  static EMAIL_VALIDATION_MESSAGE = "Invalid email address.";

  //Titles
  static DIALOG_INQUIRY_TITLE = "Once more step to view your full report";
  static DIALOG_CLAIM_TITLE = "Claim Ownership";
  static SOCIAL_SECTION_TITLE = "Or Continue with";

  //Form Labels
  static FIRST_NAME_LABEL = "First Name *";
  static LAST_NAME_LABEL = "Last Name *";
  static PHONE_NUMBER_LABEL = "Phone Number *";
  static CLAIM_EMAIL_LABEL = "Claim ownership with your email *";
  static EMAIL_LABEL = "Claim report with your email *";

  //Other Labels
  static BUTTON_LABEL = "Claim with email";
  static SUBSCRIBE_MONTHLY_REPORT = "Receive monthly property updates";

  //Social Buttons
  static APPLE_CLAIM = "Claim with Apple";
  static GOOGLE_CLAIM = "Claim with Google";
  static LINKEDIN_CLAIM = "Claim with LinkedIn";

  static APPLE_LOGIN = "Login with Apple";
  static GOOGLE_LOGIN = "Login with Google";
  static LINKEDIN_LOGIN = "Login with LinkedIn";

  //Banner Labels
  static BANNER_TITLE = "Why are we asking for this?";
  static BANNER_DESCRIPTION =
    "To ensure the security of your information, we use this data to confirm that you are a human user.";
}

export function getFormStrings(type: "inquiry" | "claim"): FormStrings {
  return {
    dialogTitle:
      type === "inquiry"
        ? Constants.DIALOG_INQUIRY_TITLE
        : Constants.DIALOG_CLAIM_TITLE,
    emailLabel:
      type === "inquiry" ? Constants.EMAIL_LABEL : Constants.CLAIM_EMAIL_LABEL,
    googleLabel:
      type === "inquiry" ? Constants.GOOGLE_LOGIN : Constants.GOOGLE_CLAIM,
    appleLabel:
      type === "inquiry" ? Constants.APPLE_LOGIN : Constants.APPLE_CLAIM,
    linkedInLabel:
      type === "inquiry" ? Constants.LINKEDIN_LOGIN : Constants.LINKEDIN_CLAIM,
  };
}
